import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { EventDetailView } from './views/EventDetailView';
import { EventFeedView } from './views/EventFeedView';
import { NotFoundView } from './views/NotFoundView';
import { StatsView } from './views/StatsView';

export function App() {
  return (
    <BrowserRouter>
      <AppShell>
        <Routes>
          <Route path="/" element={<EventFeedView />} />
          <Route path="/events/:id" element={<EventDetailView />} />
          <Route path="/stats" element={<StatsView />} />
          <Route path="*" element={<NotFoundView />} />
        </Routes>
      </AppShell>
    </BrowserRouter>
  );
}
